import { useEffect } from 'react'
import { GetServerSideProps } from 'next'
import { ListDisplayCollectionV3 } from '@/components/domains/list/list-displaycollectionV3'
import { useCustomRouter } from '@/containers/hooks'
import { DisplayCollectionProductInfosDocument } from '@/graphql/generated/hooks'
import {
  DisplayCollectionProductInfosQuery,
  DisplayCollectionProductInfosQueryVariables,
} from '@/graphql/generated/operations'
import { AdPetType } from '@/graphql/generated/schemas'
import { addApolloState, initializeApollo } from '@/utils/utilApolloClient'

interface PageSection {
  petType: AdPetType
}

const PageSection = ({ petType: ssrPetType }: PageSection) => {
  const { query, replace, pathname } = useCustomRouter()

  useEffect(() => {
    if (query?.title) {
      delete query.title
      replace({
        pathname,
        query: {
          ...query,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <ListDisplayCollectionV3 petType={ssrPetType} />
}

export default PageSection

export const getServerSideProps: GetServerSideProps = async (context) => {
  const apolloClient = initializeApollo()
  const displayCollectionId = context?.query?.displayCollectionId?.toString()

  if (!displayCollectionId) {
    return {
      notFound: true,
    }
  }

  const client = initializeApollo()
  const { data } = await client.query<DisplayCollectionProductInfosQuery, DisplayCollectionProductInfosQueryVariables>({
    query: DisplayCollectionProductInfosDocument,
    variables: {
      id: displayCollectionId,
    },
  })

  return addApolloState(apolloClient, {
    props: {
      petType: data.displayCollection?.petType,
    },
  })
}
